function* bookmarks({ bookmarks:vsBookmarks }) {
  let userBookmarks = [];

  for (const vsBookmark of vsBookmarks) {
    const userBookmark = {
      chapterTitle: vsBookmark.chapterTitle,
      cfi: vsBookmark.epubCfi,
      page: vsBookmark.page,
      createdOn: vsBookmark.markedAt,
      id: vsBookmark.guid
    };

    userBookmarks.push(userBookmark);
  }

  return userBookmarks;
}


export default bookmarks;
